<!--
 * @Author: your name
 * @Date: 2020-09-22 15:08:22
 * @LastEditTime: 2020-09-25 14:18:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-workspace/packages/xdap-h5/src/pages/form/message-remind-list/message-remind-list.vue
-->
<template>
  <div class="message-remind-list">
    <div class="list">
      <div v-for="(item, index) in remindList" :key="index" class="drawer-remind-item" @click="handleRemindDetail(item)">
        <div class="schedule-name text-ellipsis">
          {{ item.scheduleName }}
        </div>
        <x-svg-icon
          name="form-delete"
          @click.native="handleDeleteMessageRemind($event, item, index)"
        ></x-svg-icon>
      </div>
      <x-empty v-if="!remindList || remindList.length === 0"></x-empty>
    </div>
    <div
      class="list-add-icon active-style"
      @click="handleCreateMessageRemind"
    >
      <x-svg-icon name="add"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import apis from '@/api'

export default {
  name: 'MessageRemindList',
  components: {
  },
  data() {
    return {
      columns: [],
      remindList: []
    }
  },
  created() {
    this.queryPersonalMessageRemindList(this.$route.query.formId, this.$route.query.documentId)
  },
  methods: {
    handleDeleteMessageRemind(e, item, index) {
      e.preventDefault()
      e.stopPropagation()
      this.$confirm({
        message: '删除数据后不可恢复，是否确定删除？',
        okConfig: {
          onOk: () => {
            return new Promise((resolve, reject) => {
              const request = { ...apis.MESSAGE_REMIND.DELETE_PRESONAL_MESSAGE_REMIND }
              request.params = {
                scheduleId: item.scheduleId
              }
              this.$request(request)
                .asyncThen((resp) => {
                  this.remindList.splice(index, 1)
                  resolve()
                }, (error) => {
                  reject(error)
                  console.error(error)
                })
                .asyncErrorCatch(error => {
                  reject(error)
                  console.error(error)
                })
            })
          }
        },
        cancelConfig: {
          onCancel: () => {}
        }
      })
    },
    queryPersonalMessageRemindList(formId, documentId) {
      this.$loading.show()
      const request = { ...apis.MESSAGE_REMIND.QUERY_PRESONAL_MESSAGE_REMIND_LIST }
      request.params = {
        formId,
        documentId
      }
      console.log(request)
      this.$request(request)
        .asyncThen((resp) => {
          this.remindList = resp.data || []
          this.$loading.hide()
        },
        (err) => {
          this.$loading.hide()
          console.error(err)
        }
        ).asyncErrorCatch((err) => {
          this.$loading.hide()
          console.error(err)
        })
    },
    handleCreateMessageRemind() {
      this.$router.push({ name: 'SettingMessageRemind', query: this.$route.query })
    },
    handleRemindDetail(item) {
      const query = this.$lodash.cloneDeep(this.$route.query)
      query.scheduleId = item.scheduleId
      this.$router.push({ name: 'SettingMessageRemind', query: query })
    }
  }
}
</script>

<style lang="scss">
.message-remind-list {
  width: 100%;
  height: 100%;

  .list {
    width: 100%;
    height: 100%;
    padding: .571rem 1.142rem;
    box-sizing: border-box;
    background-color: $--app-body-bgColor;
    overflow-y: auto;

    .drawer-remind-item {
      margin-top: 0.57143rem;
      width: 100%;
      height: 2.571rem;
      box-sizing: border-box;
      padding: 0 .571rem 0 1.142rem;
      line-height: 2.571rem;
      font-size: $--app-base-font-size;
      display: flex;
      align-items: center;
      background-color: #FFF;
      border-radius: 2PX;
      .schedule-name {
        flex: 1;
      }
      .x-svg-icon {
        display: flex;
      }
    }
  }

  .list-add-icon {
    width: 2.857rem;
    height: 2.857rem;
    position: absolute;
    right: 1.071rem;
    bottom: 5.3%;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: $--app-light-color;
    background-color: $--app-primary-color;
    .x-svg-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
